import type { IconProps } from "./icon-types";

/**
 * 좌측 네비게이션 펼치기(expand). 헤더의 nav 토글 등에서 접힌 상태일 때 사용.
 *
 * 글리프는 sigmakit-gui가 쓰는 `react-icons/lu`의 `LuPanelLeftOpen`(Lucide `panel-left-open`)을
 * 인라인으로 재현 — c6 패키지는 외부 아이콘 라이브러리를 import하지 않으므로(RFC-design-system-split §아이콘).
 * 펼침/접힘 토글의 짝 아이콘은 PanelLeftCloseIcon.
 */
export const PanelLeftOpenIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <rect width="18" height="18" x="3" y="3" rx="2" />
    <path d="M9 3v18" />
    <path d="m14 9 3 3-3 3" />
  </svg>
);
